import { JButton } from '@components/design-system';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSafeWindowOpen } from 'src/hooks/window-utils';

interface Props {
  onRefresh?: () => void;
  onHelp?: () => void;
  title?: string;
  description?: string;
}

export default function ErrorPage({ onRefresh, onHelp, title, description }: Props) {
  const { t } = useTranslation('commons', { keyPrefix: 'error-page' });
  const { openWindow } = useSafeWindowOpen();

  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    } else {
      window.location.reload();
    }
  };

  const handleHelp = () => {
    if (onHelp) {
      onHelp();
    } else {
      openWindow({
        url: 'https://www.jooice.com/resources/guides',
        target: '_blank',
      });
    }
  };

  return (
    <Stack
      width="100%"
      spacing={1}
      alignItems="center"
      justifyContent="center"
      sx={{
        textAlign: 'center',
      }}
    >
      <Typography variant="h2" color="text.primary" fontWeight="bold">
        {title || t('title')}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {description || t('description')}
      </Typography>
      <img src="/error-page.png" alt="Error illustration" width="40%" />
      <Stack spacing={2} direction="row">
        <JButton variant="outlined" size="large" label={t('search-help-button')} onClick={handleHelp} />
        <JButton variant="contained" size="large" label={t('refresh-button')} onClick={handleRefresh} />
      </Stack>
    </Stack>
  );
}
